import { z } from 'zod';
/**
 * Ai được đổi **ngày bắt đầu / hạn** của task trong một dự án — APM-TSCH, người dùng chốt
 * 2026-10-02 sau khi một thành viên (CONTRIBUTOR) không đặt được ngày cho việc của chính mình
 * trên prod (SEED-8): trước đó luật cứng "chỉ PM đổi ngày" (2026-09-23).
 *
 * - Mặc định `pm` — đúng luật cũ, dự án có từ trước không đổi gì.
 * - PM (và quản trị tổ chức) luôn đổi được; Chỉ xem không bao giờ đổi được.
 * - Chỉ **ngày**: độ ưu tiên vẫn chỉ PM đổi (người dùng chốt cùng ngày).
 * - Cài đặt chỉ **mở thêm** quyền đổi ngày, không mở quyền sửa task: thành viên vẫn chỉ sửa
 *   được việc của mình (`task:update` own), nên `roles` nghĩa là "vai này đổi được ngày của
 *   những việc nó sửa được".
 *
 * Hàm thuần, web và API cùng dùng — như `task-status-policy.ts`.
 */
export const TaskScheduleChangePolicy = z.enum(['pm', 'assignee_or_creator', 'roles']);
export const TaskScheduleRules = z.object({
    scheduleChange: TaskScheduleChangePolicy,
    /** Chỉ có nghĩa với `scheduleChange = 'roles'`. Id của `project_role_definition`. */
    scheduleChangeRoleIds: z.array(z.uuid()).max(50),
});
export const DEFAULT_TASK_SCHEDULE_RULES = {
    scheduleChange: 'pm',
    scheduleChangeRoleIds: [],
};
const same = (a, b) => a !== null && b !== null && a.toLowerCase() === b.toLowerCase();
/** Được đổi ngày bắt đầu / hạn của task này (kể cả kéo trên Gantt). */
export function canScheduleTask(rules, actor, task) {
    if (actor.isManager)
        return true;
    if (!actor.isMember || actor.isViewer)
        return false;
    switch (rules.scheduleChange) {
        case 'pm':
            return false;
        case 'assignee_or_creator':
            return same(actor.userId, task.assigneeId) || same(actor.userId, task.createdBy);
        case 'roles':
            return rules.scheduleChangeRoleIds.some((id) => same(id, actor.roleId));
    }
}
//# sourceMappingURL=task-schedule-policy.js.map